<template>
    <v-app>
        <v-app-bar
            app
            color="secondary"
            dark
            elevation="0"
        >
            <div class="d-flex align-center primary--text">
                <v-img                
                class="shrink mr-2"
                contain
                src="../../assets/logo.png"
                transition="scale-transition"
                width="40"
                />
                {{ schoolName}}
                
            </div>

            <v-spacer></v-spacer>

            <v-btn
                color="primary"
                size="36"                
                fab
                dark
                small
                elevation="0"                
            >
            {{ userInitials }}               
            </v-btn>

            <Logout/>
        </v-app-bar>

        <v-main class="grey lighten-5" >            
            <v-container 
                fluid
                class="grey lighten-5"                               
            >                                   
                <div class="primary--text"> 
                    <span class="font-weight-light font-italic text-h5">{{ studentRecord.first_name }} {{ studentRecord.last_name }}</span>
                </div>
                <div class="primary--text"> 
                    <span class="font-weight-medium  text-subtitle-1">Student ID# {{ studentRecord.id }}</span>
                </div>
                <div class="font-weight-light text-caption">
                    {{ date }}
                </div>

                <div class="mt-3 text-center">
                    <v-chip class="ma-2" color="primary" :outlined="outlinedTermReports" href="/term-report">Term Reports</v-chip>
                    <v-chip class="ma-2" color="primary" :outlined="outlinedAttendance" href="/attendance">Attendance</v-chip>
                </div>

                <slot></slot>
                
            </v-container>                           
        </v-main>        
    </v-app> 
    
</template>

<script>
import Logout from '../auth/Logout';
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  components: {    
    Logout, 
  },

  data: () => ({
     //     
  }),

  methods: {
      //
  },

  computed: {              
      ...mapGetters({         
          schoolName: 'auth/getSchoolName',          
          studentRecord: 'auth/getStudentRecord',
      }),

      userInitials(){
          let firstNameInitial = this.studentRecord.first_name.charAt(0).toUpperCase();
          let lastNameInitial = this.studentRecord.last_name.charAt(0).toUpperCase();
          return firstNameInitial + lastNameInitial;
      },

      date(){
        const now = new Date();
        const formattedDate = now.toLocaleDateString('en-US', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
        return formattedDate;
      },

      outlinedTermReports() {
        return this.$route.name != 'termReport' 
      },

        outlinedAttendance() {
            return this.$route.name != 'attendance' 
        },

      
  }
};
</script>


